import React from 'react';
import { Popover } from 'react-bootstrap';
import FormattedDate from '../../../../components/date/FormattedDate';
import HolidayIcon from '../HolidayIcon';
import { Holiday } from './types';

type Props = {
  holiday: Holiday;
};

const HolidayPopover: React.FC<Props> = React.forwardRef<HTMLDivElement, Props>(
  ({ holiday, ...rest }, ref) => {
    const popoverProps = {
      ref,
      ...rest,
    };

    const showEndDate = holiday.endDate !== holiday.startDate;

    return (
      <Popover id={holiday.Id} {...popoverProps}>
        <Popover.Header>
          <HolidayIcon />
          <span className="ms-2">{holiday.Name}</span>
        </Popover.Header>
        <Popover.Body>
          <FormattedDate day={holiday.startDate} format="long" />
          {showEndDate && (
            <>
              &nbsp; - &nbsp;
              <FormattedDate day={holiday.endDate} format="long" />
            </>
          )}
        </Popover.Body>
      </Popover>
    );
  },
);

export default HolidayPopover;
